import { useLanguage } from "@/hooks/use-language";

export const Marquee = () => {
  const { t } = useLanguage();
  return (
    <div
      className="border-y border-border py-8 overflow-hidden select-none bg-secondary/40"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {t.marquee.map((item, i) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span
                  className={`font-display font-bold text-base lg:text-lg tracking-[0.25em] whitespace-nowrap px-8 ${
                    i % 2 === 0 ? "text-gradient" : "text-foreground"
                  }`}
                >
                  {item}
                </span>
                <span className="w-2 h-2 rotate-45 bg-gradient-to-br from-teal-500 to-green-500 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
